/**
 * Directiva utilizada para ver y añadir inspecciones a las incidencias
 */
InspeccionesDetallesDirectiva.$inject = ['lang'];
export default function InspeccionesDetallesDirectiva(lang) {
    return {
        restrict: 'AE',
        scope: {
            'incidenciaId': '=',
            'usuarioActualId': '=',
            'panel': '='
        },
        template: require('./inspeccionesDetalles.html'),
        controller: 'InspeccionesDetallesCtrl',
        link: function (scope, element, attrs, ngModelCtrl) {
            scope.directiva = true;
            scope.actualizar(scope.incidenciaId);
        }
    }
}